import { AlertTriangle } from "lucide-react";
import type { ConversationViewResponse } from "../../gen/models";

interface DeleteViewModalProps {
  isOpen: boolean;
  view: ConversationViewResponse | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting?: boolean;
}

export function DeleteViewModal({
  isOpen,
  view,
  onClose,
  onConfirm,
  isDeleting = false,
}: DeleteViewModalProps) {
  if (!isOpen || !view) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/60 backdrop-blur-xs animate-in fade-in duration-150">
      <div className="w-full max-w-sm rounded-xl bg-white dark:bg-stone-900 border border-stone-200 dark:border-stone-800 shadow-2xl overflow-hidden p-5 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-rose-100 dark:bg-rose-950/80 text-rose-600 dark:text-rose-400 flex items-center justify-center shrink-0 border border-rose-200 dark:border-rose-900">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div className="space-y-1 min-w-0">
            <h3 className="text-sm font-bold text-stone-900 dark:text-stone-100">
              Delete View?
            </h3>
            <p className="text-xs text-stone-500 dark:text-stone-400 leading-relaxed">
              Are you sure you want to delete <span className="font-semibold text-stone-800 dark:text-stone-200">"{view.name}"</span>?
              {view.is_global && " This view is shared globally across your organization."}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-stone-100 dark:border-stone-800">
          <button
            type="button"
            onClick={onClose}
            disabled={isDeleting}
            className="px-3 py-1.5 rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 text-xs font-semibold text-stone-700 dark:text-stone-300 hover:bg-stone-50 dark:hover:bg-stone-800 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-3.5 py-1.5 rounded-lg bg-rose-600 text-white text-xs font-semibold hover:bg-rose-700 transition shadow-2xs disabled:opacity-50"
          >
            {isDeleting ? "Deleting..." : "Delete View"}
          </button>
        </div>
      </div>
    </div>
  );
}
